const VERSION = '6.1.14';

export { VERSION };
